import context from "lib/stores/context";
import mapData from "lib/stores/mapData";
import extractKeyValuePairs from "./extractKeyValuePairs";

export default function setURLHash() {
  const urlSegments = new Map();

  const url = new URL(window.location.href);
  const params = extractKeyValuePairs(url);

  if (context.activeCountry) {
    urlSegments.set("country", context.activeCountry);
  }

  if (context.activeRegion) {
    urlSegments.set("region", context.activeRegion);
  }

  if (mapData.activeCategory) {
    urlSegments.set("map", mapData.activeCategory);
    switch (mapData.activeCategory) {
      case "prevalence":
        document.documentElement.style.setProperty("--color-products", "255, 92, 69");
        break;
      case "vulnerability":
        document.documentElement.style.setProperty("--color-products", "126, 178, 226");
        break;
      case "gov-response":
        document.documentElement.style.setProperty("--color-products", "255, 204, 43");
        break;
      default:
        document.documentElement.style.setProperty("--color-products", "255, 92, 69");
        break;
    }
  }

  if (mapData.year) {
    urlSegments.set("year", mapData.year);
  }

  if (mapData.selectedProduct) {
    urlSegments.set("product", mapData.selectedProduct);
  }

  if (context.activeView === "worldwide") {
    if (context.activeTabWorldwide === 0) {
      urlSegments.set("view", "countries");
    }
    if (context.activeTabWorldwide === 1) {
      urlSegments.set("view", "regions");
    }
    if (context.activeTabWorldwide === 2) {
      urlSegments.set("view", "resources");
    }
  }

  if (context.activeView === "region") {
    if (context.activeTabRegions === 0) {
      urlSegments.set("view", "countries");
    }
    if (context.activeTabRegions === 1) {
      urlSegments.set("view", "resources");
    }
    if (context.activeTabRegions === 2) {
      urlSegments.set("view", "explore");
    }
  }

  if (context.activeView === "country") {
    if (context.activeTabCountries === 0) {
      urlSegments.set("view", "recommendations");
    }
    if (context.activeTabCountries === 1) {
      urlSegments.set("view", "resources");
    }
    if (context.activeTabCountries === 2) {
      urlSegments.set("view", "explore");
    }
  }

  if (mapData.activeCategory) {
    urlSegments.set("map", mapData.activeCategory);
  }

  const urlSegmentsArray = Array.from(urlSegments.entries());

  let urlSegmentsString = "";

  if (params["mode"]) {
    urlSegmentsString = `#mode=${params["mode"]}`;
  } else {
    urlSegmentsString = "#mode=map";
  }

  urlSegmentsArray.forEach((segment, index) => {
    urlSegmentsString += `:${segment[0]}=${segment[1]}`;
  });

  url.hash = urlSegmentsString;
  if (url.hash !== window.location.hash) {
    window.history.pushState({}, "", url);
  }
}
